module.exports = __webpack_public_path__ + "static/media/calls.1f25c381.PNG";